import messages from './messages';


export function getPathMessage(path) {
  if (/rewards\/\d+$/.test(path)) {
    return messages.pathReward;
  } else if (/rewards\/\d+\/redeem-address/.test(path)) {
    return messages.pathRewardRedeemAddress;
  } else if (/rewards\/\d+\/redeem-details/.test(path)) {
    return messages.pathRewardRedeemDetails;
  } else if (/rewards\/\d+\/redeem-confirmed/.test(path)) {
    return messages.pathRewardRedeemConfirmed;
  } else if (/rewards\/\d+\/redemption/.test(path)) {
    return messages.pathRewardRedemption;
  } else if (/profiles\/\d+$/.test(path)) {
    return messages.pathProfile;
  } else if (/favorites/.test(path)) {
    return messages.pathFavorites;
  } else if (/lotteries/.test(path)) {
    return messages.pathLotteries;
  } else if (/redemptions\/\d+$/.test(path)) {
    return messages.pathRedemption;
  } else if (/redemptions/.test(path)) {
    return messages.pathRedemptions;
  } else if (/points/.test(path)) {
    return messages.pathPoints;
  } else if (/privacy/.test(path)) {
    return messages.pathPrivacy;
  } else if (/tos/.test(path)) {
    return messages.pathTerms;
  } else if (/login/.test(path)) {
    return messages.pathLogin;
  } else if (/faq/.test(path)) {
    return messages.pathLogin;
  } else if (/rewards\/\d+$/.test(path)) {
    return messages.pathReward;
  } else if (/register-caregiver/.test(path)) {
    return messages.pathCaregiver;
  }
  return messages.pathHome;
}

export function showBackButton(path) {
  if (/rewards\/.+redeem-confirmed|rewards\/.+redemption|home/.test(path)) {
    return false;
  }
  return /\/.+\//.test(path) || /privacy|terms/.test(path);
}

export const languages = [{ id: 'en', name: 'Eng' }, { id: 'es', name: 'Span' }];

